module.exports = __webpack_public_path__ + "static/media/bares-notables-de-buenos-aires.39871646.md";